import { SilentRequest, IPublicClientApplication, AccountInfo } from '@azure/msal-browser'
import { AxiosRequestConfig } from 'axios'

const scope : string = process.env.REACT_APP_SCOPE || ''
// Abstracted the previous logic for the auth
// Please improve the code/logic in the future to store the key
// and not login with every backend call
export async function getAuthConfig(
    instance: IPublicClientApplication,
    account: AccountInfo
    // extraConfig: Partial<AxiosRequestConfig> = {}
): Promise<AxiosRequestConfig> {
    const accessTokenRequest: SilentRequest = {
        scopes: [scope],
        account: account,
        forceRefresh: false,
    }
    await instance.initialize()
    const accessTokenResponse = await instance.acquireTokenSilent(accessTokenRequest)
    const accessToken: string = accessTokenResponse.accessToken
    return {
        headers: {
            'Access-Control-Allow-Origin': '*',
            accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + accessToken,
        },
        // ...extraConfig,
    }
}
